import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
const api = axios.create({
  baseURL: process.env.REACT_APP_API,
});
const ClientIdContext = createContext();
export const useClientId = () => useContext(ClientIdContext);

export const ClientIdProvider = ({ children }) => {
  const [clientId, setClientId] = useState(null);
  const [subD, setSubD] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const extractSubdomain = () => {
      const hostname = window.location.hostname;

      if (hostname === "localhost") {
        return "velvour"; // dev fallback
      }

      const parts = hostname.split(".");
      return parts.length > 2 ? parts[0] : null;
    };

    // const extractSubdomain = () => {
    //   const parts = window.location.hostname.split(".");
    //   if (parts.length >= 2 && parts[1] === "localhost") {
    //     setSubD(parts);
    //     return parts[0];
    //   }
    //   return "velvour";
    // };

    const fetchClientId = async (sub) => {
      try {
        const { data } = await api.get(`/clients/find/${sub}`);
        setClientId(data);
      } catch (err) {
        console.error("Error fetching client ID:", err);
        setError("CLIENT_NOT_FOUND");
      }
    };

    const sub = extractSubdomain();
    if (!sub) {
      setError("SUBDOMAIN_NOT_FOUND");
      return;
    }

    setSubD(sub);
    fetchClientId(sub);
  }, []);

  if (clientId === null && !error) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>{error}</div>;
  }

  return (
    <ClientIdContext.Provider value={{ clientId, subD, error }}>
      {children}
    </ClientIdContext.Provider>
  );
};
